module.exports = __webpack_public_path__ + "media/img/help_center/Student_Manage_Application_01-420df3574da1f2bd7e6af2e0d1c22584.jpg";